export const FileStatus = {
  SUCCESS: "success",
  PENDING: "processing",
  ERROR: "error",
};
